// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileStatisticsHeader_wrapper_1zxus"};